import { render, staticRenderFns } from "./HistorialPrecalificaciones.vue?vue&type=template&id=3d9d21d4&scoped=true&lang=html&"
import script from "./HistorialPrecalificaciones.vue?vue&type=script&lang=js&"
export * from "./HistorialPrecalificaciones.vue?vue&type=script&lang=js&"
import style0 from "./HistorialPrecalificaciones.vue?vue&type=style&index=0&id=3d9d21d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9d21d4",
  null
  
)

export default component.exports